<template>
    <div>
        <div class="flex-con is-grow xs-pad-lr m-b-xs">
            <div class="first-col">
                Name
            </div>
            <div>
                <div
                    class="select"
                >
                    <select
                        v-model="metaData.nameHandle"
                        @change="$refs.nameInput.focus()"
                    >
                        <option
                            v-for="(o,i) in options"
                            :key="i"
                            :value="o.handle"
                        >
                            {{o.label}}
                        </option>
                    </select>
                </div>
            </div>
            <div>
                <input
                    ref="nameInput"
                    v-model="metaData.name"
                    class="input"
                    v-validate="'required'"
                    :name="'name' + formName"
                    @keypress.enter="$emit('enter')"
                    :class="{ 'is-danger' : errors.has('name' + formName) }"
                />
            </div>
        </div>
        <div class="flex-con is-grow xs-pad-lr">
            <div class="first-col">
                Value
            </div>
            <div>
                <div
                    class="select"
                >
                    <select
                        :value="metaData.valueHandle"
                        @change="setOption('valueHandle', $event.target.value)"
                    >
                        <option
                            v-for="(o,i) in valueOptions"
                            :key="i"
                            :value="o.handle"
                        >
                            {{o.label}}
                        </option>
                    </select>
                </div>
            </div>
            <div>
                <input
                    v-show="metaData.valueHandle"
                    ref="valueInput"
                    v-validate="{ required : !!metaData.valueHandle }"
                    v-model="metaData.value"
                    class="input"
                    :name="'value' + formName"
                    @keypress.enter="$emit('enter')"
                    :class="{ 'is-danger' : errors.has('value' + formName) }"
                />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    inject : ['$validator'],
    props : {
        value : {
            type : Object,
            required : true,
        },
        field : {
            type : Object,
            required : true,
        },
        formName : {
            type : String,
            required : true,
        },
    },
    data () {
        return {
            metaData : {
                nameHandle : 'match_exact',
                name : null,
                valueHandle : null,
                value : null
            }
        }
    },
    mounted () {
        this.$refs.nameInput.focus();
    },
    watch : {
        metaData : {
            deep : true,
            immediate : false,
            handler (metaData) {
                this.$emit('input', { ...this.value, metaData : metaData });
            },
        }
    },
    computed : {
        options () {
            return [
                {
                    handle : 'match_exact',
                    label : 'Exact Match',
                },
                {
                    handle : 'match_fuzzy',
                    label : 'Fuzzy Match',
                },
                {
                    handle : 'starts_with',
                    label : 'Starts With',
                },
                {
                    handle : 'ends_with',
                    label : 'Ends With',
                },
            ];
        },
        valueOptions () {
            return [
                {
                    handle : null,
                    label : 'N/A'
                }
            ].concat(this.options);
        },
    },
    methods : {
        setOption (key, value) {
            this.$set(this.metaData, key, value);
            this.$forceUpdate();
            this.$nextTick(() => {
                if(this.$refs.valueInput) {
                    this.$refs.valueInput.focus();
                }
            });
        },
        getLabel () {
            let labels = [];
            if(this.metaData.nameHandle) {
                labels.push(`Name ${this.getOptionByHandle(this.metaData.nameHandle).label} ${this.metaData.name}`);
            }
            if(this.metaData.valueHandle) {
                labels.push(`Value ${this.getOptionByHandle(this.metaData.valueHandle).label} ${this.metaData.value}`);
            }
            return `${this.field.name} : ${labels.join(' AND ')}`;
        },
        getOptionByHandle (handle) {
            return this.options.find(o => o.handle === handle);
        },
    },
}
</script>

<style scoped>
    .first-col {
        flex:0 0 40px !important;
    }
    .select,
    select {
        width:140px;
    }
</style>
